import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import HavnsLogo from "../components/HavnsLogo";
import Footer from "../components/Footer";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FBF9F7]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#FBF9F7]/90 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
          <HavnsLogo className="text-2xl" linkTo="/" />
        </div>
      </nav>

      {/* Content */}
      <section className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-[#666] hover:text-[#1A1A1A] mb-12 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back</span>
          </button>

          <h1 className="font-serif text-4xl sm:text-5xl text-[#1A1A1A] mb-4">
            Terms of Service
          </h1>
          <p className="text-[#999] mb-12">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">1. Acceptance of Terms</h2>
              <p className="text-[#666] leading-relaxed">
                By accessing or using Havns, you agree to be bound by these Terms of Service. 
                If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">2. Membership Requirements</h2>
              <ul className="space-y-2 text-[#666]">
                <li>You must be at least 21 years of age</li>
                <li>You must complete Aadhaar KYC verification</li>
                <li>You must maintain an active subscription</li>
                <li>You must agree to our Anti-Dating Manifesto</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">3. Community Guidelines</h2>
              <p className="text-[#666] leading-relaxed mb-4">
                Havns is a strictly platonic community. Members agree to:
              </p>
              <ul className="space-y-2 text-[#666]">
                <li>Engage only in platonic interactions</li>
                <li>Respect other members' boundaries</li>
                <li>Report any romantic advances immediately</li>
                <li>Maintain professional and respectful communication</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">4. Prohibited Conduct</h2>
              <ul className="space-y-2 text-[#666]">
                <li>Romantic or sexual advances of any kind</li>
                <li>Harassment, threats, or abusive behavior</li>
                <li>Misrepresentation of identity or intentions</li>
                <li>Sharing of inappropriate content</li>
                <li>Commercial solicitation without approval</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">5. Subscription & Payments</h2>
              <p className="text-[#666] leading-relaxed">
                Membership requires a monthly subscription of ₹999. Subscriptions auto-renew 
                unless cancelled. Refunds are provided only in accordance with our refund policy.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">6. Termination</h2>
              <p className="text-[#666] leading-relaxed">
                We reserve the right to terminate or suspend your membership immediately, 
                without prior notice, for any violation of these Terms, particularly the 
                Anti-Dating Manifesto.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-2xl text-[#1A1A1A] mb-4">7. Contact</h2>
              <p className="text-[#666] leading-relaxed">
                For questions about these Terms, please contact us at legal@havns.co
              </p>
            </section>
          </div>
        </div>
      </section>

      <Footer bgColor="bg-white" />
    </div>
  );
};

export default Terms;
